import { render, staticRenderFns } from "./ProductTypeGrouped.vue?vue&type=template&id=b4ad95b6"
import script from "./ProductTypeGrouped.vue?vue&type=script&lang=ts"
export * from "./ProductTypeGrouped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports